module.exports = __webpack_public_path__ + "media/7.fe8d35e5.mp3";